var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showPoweredBy && !_vm.isUiMode && !_vm.manualHiddenPoweredBy
    ? _c(
        "footer",
        {
          staticClass: "i-footer fade-in-out",
          class: {
            "fade-in-out-active": !_vm.isPanoramasListActive,
            "screen-ready": _vm.isScreenReady,
          },
          attrs: { role: "contentinfo" },
        },
        [_vm._m(0)]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "footer-text-container" }, [
      _c(
        "a",
        {
          staticClass: "footer-text",
          attrs: { href: "https://www.istaging.com", target: "_blank" },
        },
        [_c("span", [_vm._v("Powered by iStaging")])]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "footer-text",
          attrs: {
            href: "https://www.istaging.com/legal/privacy_policy",
            target: "_blank",
          },
        },
        [_c("span", [_vm._v("Privacy policy")])]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "footer-text",
          attrs: {
            href: "https://www.istaging.com/legal/terms_of_service",
            target: "_blank",
          },
        },
        [_c("span", [_vm._v("Terms of use")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }